import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"รับบุตรบุญธรรม (Adoption) — คนไทย/ต่างชาติ + Hague Convention 1993","metaTitle":"รับบุตรบุญธรรม — ทนายจัดเตรียมคำร้อง กรมกิจการเด็ก | NYC","metaDesc":"รับบุตรบุญธรรมคนไทย ต่างชาติ Hague Convention 1993 ผ่าน กรมกิจการเด็กและเยาวชน ระยะเวลา 6-18 เดือน ทนายดูแลทุกขั้นตอน"},"en":{"h1":"Adoption — Domestic & Intercountry under Hague 1993","metaTitle":"Thailand Adoption — Domestic & Hague 1993 Intercountry | NYC","metaDesc":"Adoption filings via DCY (Department of Children and Youth). Domestic Thai adoption and Hague 1993 in — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/family/adoption")({
  head: () => {
    const url = `${SEO_SITE}/family/adoption`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/family/adoption", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/family/adoption", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/family/adoption", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/family/adoption", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/family/adoption", "/en/family/adoption")],
    };
  },
  component: () => <SubServicePage slug="family/adoption" locale="th" />,
});
